module.exports = __webpack_public_path__ + "img/PRCA2_CD4Tconv.995c080f.png";